import { toast } from "react-toastify"
import { showAccessDeniedAlert } from "./accessDenied"

const addUpdateHandlers = (data) => {

    const { res, action, navigate, success_toast, wrong_toast, navigate_route, spinner, toggle } = data;

    const isHttpOk = res?.status === 200 || res?.status === 201;
    const isApiSuccess = res?.data?.status === true;
    const successMessage = res?.data?.message || success_toast || 'Success';
    const errorMessage = res?.data?.message || wrong_toast || 'Request failed';
    const messageText = res?.data?.message?.toLowerCase?.() || '';
    const isUserExists = messageText.includes('user already exists');

    // console.log(res)
    console.log(successMessage, 'successMessage');
    console.log(errorMessage, 'errorMessage');
    console.log(messageText, 'messageText');
    console.log(isUserExists, 'isUserExists');
    console.log(isHttpOk, 'isHttpOk');
    console.log(isApiSuccess, 'isApiSuccess');
    console.log(navigate_route, 'navigate_route');
    console.log(spinner, 'spinner');
    console.log(toggle, 'toggle');

    // Success (HTTP OK + API success)
    if (isHttpOk && isApiSuccess) {
        toast.success(successMessage, { position: "bottom-right", closeOnClick: true });
        spinner(false);
        if (navigate_route == '') {
            toggle && toggle();
        } else if (navigate && navigate_route) {
            setTimeout(() => {
                navigate(navigate_route);
            }, 1500);
        }
        return;
    }

    // Special case: user already exists -> redirect to login
    if (isUserExists) {
        toast.info(res?.data?.message || 'User already exists. Please log in.', { position: "bottom-right", closeOnClick: true });
        spinner(false);
        if (navigate) {
            setTimeout(() => {
                navigate('/login');
            }, 800);
        }
        return;
    }

    // Auth errors
    if (res?.status === 401) {
        localStorage.clear();
        navigate && navigate('/login');
        spinner(false);
        return;
    }

    // Forbidden
    if (res?.status === 403) {
        showAccessDeniedAlert(navigate)
        spinner(false);
        return;
    }

    // Bad request
    if (res?.status === 400) {
        toast.error(errorMessage || '400 Bad Request', { position: "bottom-right", closeOnClick: true });
        spinner(false);
        return;
    }

    // Any other error
    toast.error(errorMessage, { position: "bottom-right", closeOnClick: true });
    spinner(false);
};

export default addUpdateHandlers;